import React from "react";
import { useTranslation } from "react-i18next";
import MessageModal from "../../../../components/messageModal";
import Icon from "components/icon";
import { icons } from "components/icon/icons";

const NotAllowedModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <MessageModal
      hasCloseButton={true}
      handleClose={onClose}
      headerText={
        <div className="row">
          <Icon
            icon={icons["error-icon"]}
            className="col-1 email-validation-img"
          />
          <div className="col row-space-between p-1">
            <span>{t("patient.programs.no_permission_modal_title")}</span>
          </div>
          <div className="hr-border-base"></div>
        </div>
      }
      body={<span>{t("patient.programs.no_permission_modal_text")}</span>}
      footerButtons={[
        <button
          className="button justify-content-center small-wider-button tertiary-button flex-fill"
          onClick={onClose}
        >
          {t("buttons.close")}
        </button>,
      ]}
    />
  );
};

export default NotAllowedModal;
